var E={50:"#F4F9F6",100:"#E8F3ED",200:"#D2E7DC",300:"#8EC2A7",400:"#409869",500:"#1E864E",600:"#1A7242",700:"#155E37",800:"#0F4327"};export{E as default};
